import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { title: String, message: String, confirmLabel: String, cancelLabel: String }

  confirm(event) {
    event.preventDefault()
    window.dispatchEvent(new CustomEvent('show-confirmation', {
      detail: {
        title: this.titleValue,
        message: this.messageValue,
        confirmLabel: this.confirmLabelValue,
        cancelLabel: this.cancelLabelValue,
        onConfirm: () => { window.location.href = this.element.href }
      }
    }))
  }
}
